import {ArtDesBeteiligtenEnum} from '../v2024';

export const ArtDesBeteiligtenEnumLabels = {
    _1: '1' as ArtDesBeteiligtenEnum,
    _3: '3' as ArtDesBeteiligtenEnum,
    _5: '5' as ArtDesBeteiligtenEnum,
    _6: '6' as ArtDesBeteiligtenEnum
};

